"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var N3Parser = require('rdf-parser-n3');
var RdfXmlParser = require('rdf-parser-rdfxml');
var JsonLdParser = require('rdf-parser-jsonld');
var common_1 = require("./common");
var responseHandler_1 = require("../src/ontodia/data/sparql/responseHandler");
var data = require('./resources/orgOntology.ttl');
var TransformingDataProvider = /** @class */ (function (_super) {
    tslib_1.__extends(TransformingDataProvider, _super);
    function TransformingDataProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransformingDataProvider.prototype.createRefQueryPart = function (params) {
        var refQueryPart = '';
        var refElementIRI = "<" + params.elementId + ">";
        var refElementLinkIRI = params.linkId ? "<" + params.linkId + ">" : undefined;
        //  link to element with specified link type
        // if direction is not specified, provide both patterns and union them
        // FILTER ISIRI is used to prevent blank nodes appearing in results
        if (params.elementId && params.linkId) {
            refQueryPart += !params.direction || params.direction === 'out' ? "\n                { " + refElementIRI + " " + refElementLinkIRI + " ?inst . FILTER ISIRI(?inst)}\n                UNION\n                { " + refElementIRI + " " + refElementLinkIRI + " ?literalId.\n    \t\t        ?property <http://wikiba.se/ontology#directClaim> " + refElementLinkIRI + ".\n    \t\t        ?property wdt:P1630|wdt:P1921 ?template.\n                    BIND(IRI(REPLACE(?template, \"\\\\$1\", ?literalId)) as ?inst)\n                }\n                " : '';
            refQueryPart += !params.direction ? ' UNION ' : '';
            refQueryPart += !params.direction ||
                params.direction === 'in' ?
                "{  ?inst " + refElementLinkIRI + " " + refElementIRI + " . FILTER ISIRI(?inst)}" : '';
        }
        // all links to current element
        if (params.elementId && !params.linkId) {
            refQueryPart += !params.direction || params.direction === 'out' ? "\n                { " + refElementIRI + " ?link ?inst . FILTER ISIRI(?inst)}\n                UNION\n                { " + refElementIRI + " ?link ?literalId.\n    \t\t        ?property <http://wikiba.se/ontology#directClaim> ?link.\n    \t\t        ?property wdt:P1630|wdt:P1921 ?template.\n                    BIND(IRI(REPLACE(?template, \"\\\\$1\", ?literalId)) as ?inst)\n                }\n                " : '';
            refQueryPart += !params.direction ? ' UNION ' : '';
            refQueryPart += !params.direction ||
                params.direction === 'in' ?
                "{  ?inst ?link " + refElementIRI + " . FILTER ISIRI(?inst)}" : '';
        }
        return refQueryPart;
    };
    TransformingDataProvider.prototype.linksInfo = function (params) {
        var ids = params.elementIds.map(function (uri) { return "<" + uri + ">"; }).map(function (id) { return " ( " + id + " )"; }).join(' ');
        var query = "PREFIX wdt: <http://www.wikidata.org/prop/direct/>\n\n            SELECT ?source ?type ?target\n            WHERE {\n                VALUES (?source) {" + ids + "}\n                VALUES (?target) {" + ids + "}\n                {?source ?type ?target.}\n                UNION\n                {\n                    ?source ?type ?literalId.\n                    FILTER(ISLITERAL(?literalId))\n    \t\t        ?property <http://wikiba.se/ontology#directClaim> ?type.\n    \t\t        ?property wdt:P1630|wdt:P1921 ?template.\n                    BIND(IRI(REPLACE(?template, \"\\\\$1\", ?literalId)) as ?createdTarget)\n                    BIND(?createdTarget as ?target)\n                    FILTER (BOUND(?createdTarget))\n                }\n            }\n        ";
        return this.executeSparqlQuery(query).then(responseHandler_1.getLinksInfo);
    };
    return TransformingDataProvider;
}(index_1.SparqlDataProvider));
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var rdfDataProvider = new index_1.RDFDataProvider({
        data: [
            { content: data, type: 'text/turtle' },
        ],
        dataFetching: true,
        parsers: {
            'text/turtle': new N3Parser(),
            'application/rdf+xml': new RdfXmlParser(),
            'application/ld+json': new JsonLdParser(),
        },
    });
    var sparqlDataProvider = new TransformingDataProvider({
        endpointUrl: '/wikidata',
        imagePropertyUris: [
            'http://www.wikidata.org/prop/direct/P18',
            'http://www.wikidata.org/prop/direct/P154',
        ],
        queryMethod: index_1.SparqlQueryMethod.POST,
    }, tslib_1.__assign(tslib_1.__assign({}, index_1.WikidataSettings), {
        linkTypesOfQuery: "SELECT DISTINCT ?link\n        WHERE {\n            {\n                ${elementIri} ?link ?outObject\n                # this is to prevent some junk appear on diagram,\n                # but can really slow down execution on complex objects\n                #FILTER ISIRI(?outObject)\n                #FILTER EXISTS { ?outObject ?someprop ?someobj }\n            } UNION {\n                ?inObject ?link ${elementIri}\n                #FILTER ISIRI(?inObject)\n                #FILTER EXISTS { ?inObject ?someprop ?someobj }\n            } UNION {\n                ${elementIri} ?link ?outObject.\n                ?property <http://wikiba.se/ontology#directClaim> ?link.\n            }\n            FILTER regex(STR(?link), \"direct\")\n        }",
        linkTypesStatisticsQuery: "SELECT ?link ?outCount ?inCount\n        WHERE {\n            {{\n                SELECT (${linkId} as ?link) (count(?outObject) as ?outCount) WHERE {\n                    ${elementIri} ${linkId} ?outObject\n                    FILTER ISIRI(?outObject)\n                    FILTER EXISTS { ?outObject ?someprop ?someobj }\n                } LIMIT 101\n            } {\n                SELECT (${linkId} as ?link) (count(?inObject) as ?inCount) WHERE {\n                    ?inObject ${linkId} ${elementIri}\n                    FILTER ISIRI(?inObject)\n                    FILTER EXISTS { ?inObject ?someprop ?someobj }\n                } LIMIT 101\n            }} UNION {\n                SELECT (${linkId} as ?link) (count(?outObject) as ?outCount) (0 as ?inCount) WHERE {\n                    ${elementIri} ${linkId} ?outObject.\n                    ?property <http://wikiba.se/ontology#directClaim> ${linkId}.\n                } LIMIT 101\n            }\n        }",
        filterAdditionalRestriction: "FILTER ISIRI(?inst)\n                        BIND(STR(?inst) as ?strInst)\n",
    }));
    var diagram = common_1.tryLoadLayoutFromLocalStorage();
    workspace.getModel().importLayout({
        diagram: diagram,
        validateLinks: true,
        dataProvider: new index_1.CompositeDataProvider([
            { name: 'SPARQL Provider', dataProvider: sparqlDataProvider },
            { name: 'RDF Provider', dataProvider: rdfDataProvider },
        ], { mergeMode: 'sequentialFetching' }),
    });
}
var props = {
    ref: onWorkspaceMounted,
    onSaveDiagram: function (workspace) {
        var diagram = workspace.getModel().exportLayout();
        window.location.hash = common_1.saveLayoutToLocalStorage(diagram);
        window.location.reload();
    },
    viewOptions: {
        onIriClick: function (_a) {
            var iri = _a.iri;
            return window.open(iri);
        },
    },
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
